import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ICustomer } from '@ruby/modules/customer-select/models/customer.interface';
import { selectThirdPartyStepperWithCustomer } from '@ruby/modules/third-party/store';
import * as ThirdPartyCompaniesActions from '@ruby/modules/third-party/store/actions/third-party-companies.actions';
import { fromThirdPartyCore } from '@ruby/modules/third-party/store/third-party-core.index';
import { fromThirdPartyStepper, ThirdPartyStepperActions } from '@ruby/modules/third-party/store/third-party-stepper.index';

@Component({
  selector: 'ng-select-company-container',
  templateUrl: './select-company.container.html',
  styleUrls: ['./select-company.container.scss']
})
export class SelectCompanyContainerComponent {
  customers!: Array<ICustomer>;
  store$: Observable<{ core: fromThirdPartyCore.State; stepper: fromThirdPartyStepper.State; customers: Array<ICustomer> }>;

  constructor(private store: Store<fromThirdPartyCore.State>) {
    this.store$ = this.store.select(selectThirdPartyStepperWithCustomer);
  }

  /**
   * Selected Customer
   *
   * @summary The following method dispatch an action to select the customer
   * @param $customer: ICustomer
   * @returns void
   */
  selectedCustomer($customer: ICustomer): void {
    this.store.dispatch(ThirdPartyCompaniesActions.setCustomerCompany({ data: $customer }));
  }

  /**
   * Next Step
   *
   * @summary Move the stepper forward when there is only one company
   * @returns void
   */
  nextStep(): void {
    this.store.dispatch(ThirdPartyStepperActions.setStepIndex({ data: 1 }));
  }
}
